
import { defineComponent } from "vue";

export default defineComponent({
  name: "intro-content",
  props: {
    headerImage: {
      type: String,
      default: "",
    },
    introHtml: {
      type: String,
      default: "",
    },
    pdfResumen: {
      type: String,
      default: "",
    },
    pdfResumenName: {
      type: String,
      default: "",
    },
    pdfPrograma: {
      type: String,
      default: "",
    },
    pdfProgramaName: {
      type: String,
      default: "",
    },
  },
  setup() {
    // Función segura para decodificar e interactuar con el PDF Base64
    const openPdf = (base64String: string, filename: string) => {
      if (!base64String) return;

      try {
        const parts = base64String.split(";base64,");
        const contentType = parts[0].split(":")[1];
        const raw = window.atob(parts[1]);
        const rawLength = raw.length;
        const uInt8Array = new Uint8Array(rawLength);

        for (let i = 0; i < rawLength; ++i) {
          uInt8Array[i] = raw.charCodeAt(i);
        }

        const blob = new Blob([uInt8Array], { type: contentType });
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, "_blank");
      } catch (error) {
        console.error("Error al abrir el PDF:", error);
      }
    };

    return {
      openPdf,
    };
  },
});
